import { ROLES, ACTIONS } from '../../plugins/types';

const isRole = {
    admin: ({role}) =>  role === ROLES.ADMIN,
    key_account: ({role}) =>  role === ROLES.KEY_ACCOUNT,
    sales: ({role}) =>  role === ROLES.SALES,
    operator: ({role}) =>  role === ROLES.OPERATOR,
    partner: ({role}) =>  role === ROLES.PARTNER,
    shop_owner: ({role}) =>  role === ROLES.SHOP_OWNER 
};

const isLoggedIn = ({loggedIn}) => loggedIn;

const registrationRoleAccess = {
    [ROLES.ADMIN]: [ROLES.ADMIN, ROLES.KEY_ACCOUNT, ROLES.SHOP_OWNER, ROLES.SALES, ROLES.OPERATOR, ROLES.PARTNER],
    [ROLES.SALES]: [ROLES.KEY_ACCOUNT, ROLES.SHOP_OWNER, ROLES.SALES, ROLES.OPERATOR, ROLES.PARTNER],
    [ROLES.KEY_ACCOUNT]: [ROLES.SHOP_OWNER, ROLES.OPERATOR],
    [ROLES.SHOP_OWNER]: [ROLES.OPERATOR],
    [ROLES.PARTNER]: [],
    [ROLES.OPERATOR]: []
};


const registrationActionsAccess = {
    [ROLES.ADMIN]: [ACTIONS.READ, ACTIONS.ADD, ACTIONS.UPDATE, ACTIONS.REMOVE],
    [ROLES.SALES]: [ACTIONS.READ, ACTIONS.ADD, ACTIONS.UPDATE, ACTIONS.REMOVE],
    [ROLES.KEY_ACCOUNT]: [ACTIONS.READ, ACTIONS.ADD, ACTIONS.UPDATE, ACTIONS.REMOVE],
    [ROLES.SHOP_OWNER]: [ACTIONS.READ, ACTIONS.ADD, ACTIONS.UPDATE, ACTIONS.REMOVE],
    [ROLES.PARTNER]: [],
    [ROLES.OPERATOR]: []
};

const canAdd = ({child, role}) => {
    if(!registrationRoleAccess[child.role] || !role) {
        return false;
    }
    return registrationRoleAccess[child.role].indexOf(role) !== -1;
};

const canPerformAction = ({child, action}) => {
    if(!registrationActionsAccess[child.role] || !action) {
        return false;
    }
    return registrationActionsAccess[child.role].indexOf(action) !== -1;
};

export {
    isRole,
    isLoggedIn,
    canAdd,
    canPerformAction
};
